<template>
  <div v-if="response">
    <b-card>
      <h5 class="mb-3">📦 Import Result Summary</h5>
      <b-row>
        <b-col cols="12" md="4">
          <b-alert class="p-2" show variant="secondary"
            >Total Rows:
            <strong class="ml-2"> {{ response.total_rows }}</strong></b-alert
          >
        </b-col>
        <b-col cols="12" md="4">
          <b-alert class="p-2" show variant="success"
            >Success:
            <strong class="ml-2">{{ response.success_count }}</strong></b-alert
          >
        </b-col>
        <b-col cols="12" md="4">
          <b-alert class="p-2" show variant="danger"
            >Errors: <strong class="ml-2">{{ response.error_count }}</strong>
          </b-alert>
        </b-col>
      </b-row>
    </b-card>
    <!-- Success Data -->
    <b-card
      v-if="response.success_data && response.success_data.length"
      border-variant="success"
    >
      <h5 class="text-success mb-3">✅ Success Data</h5>
      <b-table
        striped
        hover
        small
        :items="response.success_data"
        :fields="successFields"
      >
        <template #cell(days_processed)="data">
          {{ data.item.days_processed }} days
        </template>
      </b-table>
    </b-card>

    <!-- Error Data -->
    <b-card
      v-if="response.errors && response.errors.length"
      border-variant="danger"
    >
      <h5 class="text-danger mb-3">❌ Error Data</h5>
      <b-table
        striped
        hover
        small
        :items="response.errors"
        :fields="errorFields"
        thead-class="text-nowrap"
      >
        <template #cell(errors)="data">
          <ul class="mb-0">
            <li v-for="(err, index) in data.item.errors" :key="index">{{
              err
            }}</li>
          </ul>
        </template>
        <template #cell(fleet_name)="data">
          <div class="text-nowrap">{{ data.item?.fleet_name ?? '-' }}</div>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'ImportResultRh',
  props: {
    response: {
      type: Object,
      default: () => {},
    },
    successFields: {
      type: Array,
      default: () => [
        { key: 'row', label: 'Row' },
        { key: 'fleet_name', label: 'Fleet Name' },
        { key: 'power_type', label: 'Power Type' },
        { key: 'power_series', label: 'Power Series' },
        { key: 'days_processed', label: 'Days Processed' },
      ],
    },
    errorFields: {
      type: Array,
      default: () => [
        { key: 'row', label: 'Row' },
        { key: 'fleet_name', label: 'Fleet Name' },
        { key: 'errors', label: 'Error Messages' },
      ],
    },
  },
  data() {
    return {}
  },
}
</script>

<style scoped>
ul {
  padding-left: 1.2rem;
}
</style>
